import type { TransactionOperation } from "."
import { findProjectedAreaState } from "../areas"
import { areasOfPanelsIndexState } from "../relations"

export const getAzimuthFromPanelArea: TransactionOperation<string, number> = (
  transactors,
  panelId,
) => {
  const { get } = transactors
  const currentAreaId = get(areasOfPanelsIndexState).from(panelId)
  const { azimuth } = currentAreaId
    ? get(findProjectedAreaState(currentAreaId))
    : { azimuth: 0 }

  return Math.round(azimuth ?? 0)
}
